import { api } from "@/lib/api";
import { usePolling } from "@/hooks/usePolling";
import { RootCauseConsolidation } from "@/components/findings/RootCauseConsolidation";
import { ValueStateFunnel } from "@/components/economics/ValueStateFunnel";

export default function Opportunities() {
  const consolidated = usePolling(() => api.get("/findings/root-cause-consolidation").then((r) => r.data), 6000);
  const funnel = usePolling(() => api.get("/opportunities/funnel").then((r) => r.data), 6000);

  const createAction = async (item) => {
    const oppId = `OPP-${item.finding_ids[0].split("-", 2)[1]}`;
    await api.post("/actions", { opportunity_id: oppId });
  };

  return (
    <div className="space-y-6" data-testid="opportunities-page">
      <h1 className="text-2xl font-bold font-heading text-[var(--oim-text)]">Opportunities</h1>
      <div className="grid grid-cols-1 lg:grid-cols-3 gap-4">
        <div className="lg:col-span-2 space-y-3">
          {!consolidated.data ? (
            <div className="text-sm text-[var(--oim-text-muted)]" data-testid="opportunities-loading">Loading…</div>
          ) : consolidated.data.length === 0 ? (
            <div className="text-sm text-[var(--oim-text-muted)]" data-testid="opportunities-empty">
              No findings currently open. Inject a scenario from the Simulation page to generate root-cause findings.
            </div>
          ) : (
            consolidated.data.map((item) => <RootCauseConsolidation key={item.root_cause} item={item} onCreateAction={createAction} />)
          )}
        </div>
        <div className="rounded-xl border p-4" style={{ borderColor: "var(--oim-border)", backgroundColor: "var(--oim-surface)" }}>
          <div className="text-sm font-heading font-bold text-[var(--oim-text)] mb-3">Value State Funnel</div>
          {funnel.data && <ValueStateFunnel funnel={funnel.data} testId="value-state-funnel-opportunities" />}
        </div>
      </div>
    </div>
  );
}
